import React, {useState, useEffect} from 'react'
import { toast } from 'react-toastify';
import { useAddPauseCodeMutation } from '../../../../Services/Telephony/Telephony';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
interface IPROPS {
    closeModal:any
    refetch:any
    pauseCode:any
}

const AddPauseCode: React.FC<IPROPS> = ({closeModal, refetch, pauseCode}) => {
    const [name, setName] = useState('')
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [addPauseCodeTrigger] = useAddPauseCodeMutation()
//   const [pcDuration, setPcDuration] = useState("00:00:00");

// const handleDurationChange = (e) => {
//     setPcDuration(e.target.value);
// };

    // const [pcDuration, setPcDuration] = useState(dayjs().startOf('day'));
    const [pcDuration, setPcDuration] = useState<dayjs.Dayjs | null>(null);

    const handleDurationChange = (newValue: dayjs.Dayjs | null) => {
            if (newValue) setPcDuration(newValue);
        };

    const handleSubmit = async(e) => {
        e.preventDefault()

        const manualDialExists = pauseCode?.some(
            (el) => el?.name?.toLowerCase() === "manual dial"
        );
    
        const notReadyExists = pauseCode?.some(
            (el) => el?.name?.toLowerCase() === "not ready"
        );
    
        if (name.trim().toLowerCase() === "manual dial" && manualDialExists) {
            toast.error("Manual Dial already exists");
            return;
        }
    
        if (name.trim().toLowerCase() === "not ready" && notReadyExists) {
            toast.error("Not Ready already exists");
            return;
        }
         const lowerName = name.trim().toLowerCase();

        // Check for duplicates
        if (pauseCode?.some((el) => el?.name?.toLowerCase() === lowerName)) {
            toast.error(`${name}  already exists.`);
            return;
        }
        // const addExtensionObj = {
        //     name: name,
        //     // pc_duration:pcDuration
        //      pc_duration: pcDuration.format('HH:mm:ss'),
        // }
            const addExtensionObj: any = {
            name: name.trim()
            };

            if (pcDuration) {
            addExtensionObj.pc_duration = pcDuration.format('HH:mm:ss');
            }

        const response  = await addPauseCodeTrigger(addExtensionObj)

        // restrict "not ready" as well. 

        try {

            if (response?.data) {
                toast.success("AUX code  added successfully")
                closeModal()
                refetch()

                setIsButtonDisabled(true);

                setTimeout(() => {
                  setIsButtonDisabled(false);
                }, 3000);

            }
            else if ("data" in response.error) {
                const errorData = response?.error?.data as {name: string[]}
                const errorMessage = errorData?.name[0]
                toast.error(errorMessage)
                setIsButtonDisabled(true);

                setTimeout(() => {
                  setIsButtonDisabled(false);
                }, 3000);

            }
            
        } catch (error) {
            setIsButtonDisabled(true);

            setTimeout(() => {
              setIsButtonDisabled(false);
            }, 3000);

            
        }

    }



    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div>
            <label>AUX code</label>
            <input
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
        </div>
        {/* <div>
    <label>Duration (HH:MM:SS)</label>
    <input
        type="time"
        step="1" // Enables seconds in the input
        className="form-control"
        value={pcDuration}
        onChange={handleDurationChange}
    />
</div> */}

 <div>
                <label>Duration (HH:MM:SS)</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                        views={['hours', 'minutes', 'seconds']}
                        ampm={false}
                        value={pcDuration}
                        onChange={handleDurationChange}
                        sx={{
                            width: '100%',
                            '& .MuiInputBase-root': {
                                width: '100%',
                            },
                        }}
                        slotProps={{
                            textField: {
                                placeholder: '00:00:00',
                            },
                        }}
                    />
                </LocalizationProvider>
            </div>

        <div
            style={{
                width: "100%",
                display: "flex",
                gap: "10px",
                justifyContent: "end",
            }}
        >
            <button 
            
           type="reset"
                    className="btn btn-sm btn-white me-2"
            onClick={() => closeModal()}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmit} disabled={isButtonDisabled}>
                Save
            </button>
        </div>
    </div>  )
}

export default AddPauseCode